import { useSelector } from "react-redux";
import "./style.css"

function Message() {
    const msg = useSelector(state => state.message);

    return msg && (
        <div className="message">
            <p>{msg}</p>
        </div>
    )
}

export default Message;